<template>

  <table class="el-table" v-if="ways">
    <tr>
      <th>Ways</th>
      <th>Sharers</th>
      <th>Percent</th>
    </tr>
    <tr v-for="w in ways">
      <td>{{w.ways}}</td>
      <td>{{w.sharers}}</td>
      <td>{{w.percent}}%</td>
    </tr>
  </table>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'

export default {

  mixins: [PostMixins],

  methods: {

    fillWays (data) {
      this.ways = data
    }

  },


  data () {

    return {
      ways: this.waysData
    }

  },

  created () {
    this.fetchData('/report/sharing', this.fillWays)
  }



}
</script>



// WEBPACK FOOTER //
// WaysSummaryReport.vue?028a9a49